<div class="campaign-quicksearch--wrapper campaign-quicksearch--has-filter-btn">
    <mat-form-field class="col__ no-label mb-0 bblr-0 bbrr-0"
                    [ngClass]="{'loading': loading}">
      <mat-icon matIconPrefix
              fontSet="far fa-fw"
              fontIcon="fa-magnifying-glass"
              class="color--gray--007"
              *ngIf="!loading"></mat-icon>
      <mat-icon matIconPrefix
                fontSet="far fa-fw"
                fontIcon="fa-spinner"
                class="color--gray--007 fa-spin"
                *ngIf="loading"></mat-icon>
        <input matInput
               placeholder="Search campaigns"
               name="campaign-search"
               [formControl]="filterInput"
               (keydown.arrowdown)="focusResults()"
               autocomplete="off">
    </mat-form-field>
    <button mat-button
            [matMenuTriggerFor]="beforeMenu"
            class="campaign-quicksearch__filter-btn"
            [innerHTML]="selectedVisibilityOption?.label">
    </button>
    <mat-menu #beforeMenu="matMenu"
              xPosition="before"
              class="campaign-quicksearch__filter-menu">
        <button mat-menu-item
                *ngFor="let option of visiblityOptions"
                (click)="visibiltyOptionChanged(option)"
                [ngClass]="{active: option?.value === selectedVisibilityOption?.value}"
                [innerHTML]="option.label"></button>
    </mat-menu>

    <section (keydown)="onResultsListKeydown($event)"
             tabindex="0">
        <cdk-virtual-scroll-viewport class="campaign-quicksearch__results"
                                     itemSize="48"
                                     #scrollContainer
                                     minBufferPx="200"
                                     maxBufferPx="400"
                                     style="height: 250px;">

            <ng-container *cdkVirtualFor="let result of results">

                <app-list-item [item]="result"
                               class="campaign-result"
                               (click)="itemClicked(result)">

                    <span class="campaign-result__icon">
                        <i class="far fa-check"
                           *ngIf="result.visibleInCampaign"></i>
                    </span>
                    <span class="campaign-result__name truncate">
                        {{result.campaignName}}
                    </span>
                    <span class="campaign-result__link">Manage</span>

                </app-list-item>
            </ng-container>
        </cdk-virtual-scroll-viewport>

    </section>
</div>
